export default "__VITE_ASSET__CrimS3Yp__"